<template>
  <page>
    <!-- Keep for further need or enhancement -->
    <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          {{ labels.newButton }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.paramName }}</td>
                <td class="text-xs-left">{{ row.item.paramDesc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item.paramName)"
                    query
                    @query="doQuery(row.item.paramName)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <!--Start Dialog Reivew-->
    <v-dialog v-model="reviewDialog" width="800px" persistent>
      <v-card>
        <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>{{ labels.reviewMode }}</v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>{{ labels.queryMode }}</v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>{{ labels.newMode }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  :label="labels.paramName"
                  v-model="form.paramName"
                  :error-messages="errors.collect('paramName')"
                  data-vv-name="paramName"
                  :data-vv-as="labels.paramName"
                  v-validate="'required|param|max:8'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.paramName }}</v-subheader>
                <div class="queryValue">{{ form.paramName }}</div>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.paramDesc }}</v-subheader>
                <div class="queryValue">{{ form.paramDesc }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  :label="labels.paramDesc"
                  v-model="form.paramDesc"
                  :error-messages="errors.collect('paramDesc')"
                  data-vv-name="paramDesc"
                  :data-vv-as="labels.paramDesc"
                  v-validate="'required|max:80'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ form.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ form.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
          <v-btn v-show="!queryMode" color="primary" text @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Review Dialog -->
    <!--Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>{{ labels.promptRemove }}</p>
      <div class="queryValue">{{ selected.paramName }} - {{ selected.paramDesc }}</div>
    </confirm>
    <!-- End Delete Prompt-->
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      stmtLnGL: 'stmtLnGL',
      headers: [
        { text: 'Statement Line GL Code', value: 'paramName' },
        { text: 'Statement Line GL Code Description', value: 'paramDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        paramName: 'Statement Line GL Code',
        paramDesc: 'Statement Line GL Code Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        queryMode: 'Query Statement Line GL Code',
        newMode: 'Create Statement Line GL Code',
        reviewMode: 'Edit Statement Line GL Code',
        promptRemove: 'Are you sure you want to delete the selected Statement Line GL Code?',
        newButton: 'New Statement Line GL Code'
      },
      form: {
        // actionKey: 'vslFlag',
        paramName: null,
        paramDesc: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        paramType: null,
        actionName: null
      },
      selected: {
        paramName: null,
        paramDesc: null
      },
      promptRemove: false,
      queryMode: false,
      reviewMode: false,
      reviewDialog: false,
      newMode: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.stmtType.menu
    }
  },
  methods: {
    init() {
      this.doInit(this.stmtLnGL)
    },
    doInit(pKey) {
      const apiURI = this.menu.getStmtLnGLList
      if (apiURI) {
        const params = {
          paramKey: pKey,
          paramString: ''
        }
        this.loading = true
        this.$http
          .get(expandURI(apiURI, params))
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((result) => {
                const convertList = {
                  paramName: result.paramName,
                  paramDesc: result.paramDesc
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.form.paramName = null
      this.form.paramDesc = null
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
      this.form.modifiedBy = null
      this.form.modifiedDate = null
      this.queryMode = false
      this.newMode = true
      this.reviewMode = false
      this.reviewDialog = true
    },
    doQuery(paramName) {
      this.queryMode = true
      this.newMode = false
      this.reviewMode = false
      this.doFetchData(paramName)
    },
    doReview(paramName) {
      this.queryMode = false
      this.newMode = false
      this.reviewMode = true
      this.doFetchData(paramName)
    },
    doPromptRemove(item) {
      this.selected.paramName = item.paramName
      this.selected.paramDesc = item.paramDesc
      this.promptRemove = true
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.paramName) {
        const apiURI = this.menu.performAction
        if (apiURI) {
          const expand = {
            paramName: this.selected.paramName,
            paramType: this.stmtLnGL,
            actionName: 'DELETE'
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.init()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doTransaction('CREATE')
          } else {
            this.doTransaction('UPDATE')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doTransaction(actionName) {
      const apiURI = this.menu.performAction
      this.form.actionName = actionName
      this.form.paramType = this.stmtLnGL
      if (apiURI) {
        this.$http
          .post(apiURI, this.form)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.init()
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.form.paramName = null
      this.form.paramDesc = null
      this.reviewDialog = false
      setTimeout(() => {
        this.newMode = false
        this.queryMode = false
        this.reviewMode = false
      }, 200)
    },
    doFetchData(paramName) {
      this.resetValidator()
      this.resetMessages()
      if (paramName) {
        const apiURI = this.menu.getStmtLnGL
        const expand = { paramKey: this.stmtLnGL, paramString: paramName }
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.form.paramName = data.stmtLnGL.paramName
                this.form.paramDesc = data.stmtLnGL.paramDesc
                this.form.createdBy = data.stmtLnGL.createdBy
                this.form.createdDate = data.stmtLnGL.createdDate
                this.form.modifiedBy = data.stmtLnGL.modifiedBy
                this.form.modifiedDate = data.stmtLnGL.modifiedDate
                this.reviewDialog = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    }
  },
  created() {
    this.init()
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
